import HeroArchitecture from '@/views/ai-home/HeroArchitecture';
import McpChatDemo from '@/views/ai-home/demos/McpChatDemo';

/**
 * 통합 메인 공용 섹션.
 * - DataShowcase : 공공데이터 + 공공서비스(DSP) 역량을 카드 스택으로
 * - AiBlock      : AI 페이지의 채팅 UI + 아키텍처를 재사용(화이트 톤 리컬러)
 * - CtaBand      : 마무리 행동유도
 */

// 공공데이터 / 공공서비스 역량 (실제 이력 기반)
const CAPS = [
  { name: 'Data Infuser', meta: '데이터 개방·구축', group: 'data' },
  { name: 'OpenAPI 개방', meta: '표준 API 제공', group: 'data' },
  { name: 'AI Data Verifier', meta: '데이터 품질 검증', group: 'data' },
  { name: 'API 품질관리', meta: '공공서비스 · DSP', group: 'svc' },
  { name: 'Swagger 기반 명세', meta: 'API 명세 표준화', group: 'svc' },
  { name: '실시간 데이터 연계', meta: '교통·유통·금융', group: 'svc' },
];

export function DataShowcase({ reverse }: { reverse?: boolean }) {
  return (
    <div className={`mh-showcase${reverse ? ' mh-showcase--rev' : ''}`}>
      <div>
        <span className="mh-eyebrow">PUBLIC DATA · SERVICE</span>
        <h3 className="mh-showcase__title">
          공공데이터와 공공서비스를
          <br />
          함께 책임집니다
        </h3>
        <p className="mh-showcase__desc">
          국가중점·금융공공데이터를 구축·개방하고 AI 기반으로 품질을 검증합니다. 공공서비스 사업에서 쌓은 API 품질관리와
          Swagger 기반 명세 역량으로 신뢰할 수 있는 데이터·서비스를 만듭니다.
        </p>
        <ul className="mh-showcase__list">
          <li className="mh-showcase__li">데이터 개방·구축·표준화 (Data Infuser · OpenAPI)</li>
          <li className="mh-showcase__li">AI 기반 데이터 품질 검증·정제 (Data Verifier)</li>
          <li className="mh-showcase__li">공공서비스 API 품질관리 · Swagger 명세</li>
        </ul>
        <a className="mh-cta" style={{ color: 'var(--red)' }} href="/data">
          공공데이터 자세히 보기 →
        </a>
      </div>
      <div className="mh-showcase__visual">
        <div className="mh-datastack">
          {CAPS.map((c) => (
            <div className="mh-datastack__row" key={c.name}>
              <span className={`mh-datastack__dot mh-datastack__dot--${c.group}`} />
              <span className="mh-datastack__name">{c.name}</span>
              <span className="mh-datastack__meta">{c.meta}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/**
 * AI 섹션 — AI 페이지의 채팅 데모 + 통합 아키텍처를 재사용하고
 * `.mh-ai` 스코프 SCSS로 다크/네온을 화이트/레드 톤으로 리컬러한다.
 */
export function AiBlock() {
  return (
    <div className="mh-ai">
      <div className="mh-ai__grid">
        <div className="mh-ai__chat">
          <McpChatDemo />
        </div>
        <div className="mh-ai__arch">
          <HeroArchitecture />
        </div>
      </div>
    </div>
  );
}

export function CtaBand() {
  return (
    <div className="mh-cta-band">
      <div className="mh-cta-band__title">공공의 가치를 데이터와 AI로 연결하겠습니다</div>
      <div className="mh-cta-band__sub">공공데이터·AI 프로젝트, 프롬프트테크놀로지와 함께 시작하세요.</div>
      <a className="mh-cta-band__btn" href="/aboutus">
        회사 소개 보기 →
      </a>
      <span className="mh-cta-band__hex" />
    </div>
  );
}
